import React, {useState} from "react";
import * as t from "./types";

interface RegistrationListProps {
  registrations: t.ITrainingRegistration[];
}

export const RegistrationList = (props: RegistrationListProps) => {
  const {registrations} = props;
  const reglist = registrations.map((r) => {
    return <div>{r.name}</div>;
  });
  const [isShow, setIsShow] = useState(false);
  const toggleReglist = () => {
    setIsShow(!isShow);
  };
  const regarea = isShow ? <div>{reglist}</div> : <div></div>;
  return (
    <div>
      <button onClick={toggleReglist}>
        {isShow ? "Teilnehmer Schließen" : "Teilnehmer Zeigen"}
      </button>
      {regarea}
    </div>
  );
};
